import { createLucideIcon } from 'lucide-react';
export const DoubleCheck = createLucideIcon('double-Check', [
  [
    'path',
    {
      d: 'M8.5 15L19.5 5L8.5 19L4 12.5C4 12.5 8.65867 15.0231 8.5 15Z',
      key: '5wubah',
    },
  ],
  [
    'path',
    {
      d: 'M8.50311 14.9972L19.5 5L8.5 19L4 12.5C4 12.5 8.43259 14.9007 8.50311 14.9972Z',
      key: 'reff45',
    },
  ],
]);
